import { render, staticRenderFns } from "./review-limit-day.vue?vue&type=template&id=1595c32b&scoped=true"
import script from "./review-limit-day.vue?vue&type=script&lang=js"
export * from "./review-limit-day.vue?vue&type=script&lang=js"
import style0 from "./review-limit-day.vue?vue&type=style&index=0&id=1595c32b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1595c32b",
  null
  
)

export default component.exports